import { app } from '../../../../app';
import { Controller } from './add-new-company.controller';

app.component('companyResellerAddNewCompany', {
    bindings: {
        account: '<',
        administrators: '<',
        companyId: '<',
    },
    controller: Controller,
    templateUrl: require('./add-new-company.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/reseller/add-new-company/add-new-company.component.js